// extracted by mini-css-extract-plugin
export default {"wrapper":"JwCx2YWJuqKEEEUJf3mF"};